import { Component, OnDestroy, OnInit } from "@angular/core";
import { TypeaheadMatch, TypeaheadModule } from "ngx-bootstrap/typeahead";
import { QuickbooksIntegrationService } from "src/app/dashboard/quickbooks-integration.service";
import { BsModalRef } from "ngx-bootstrap/modal";
import { FormsModule } from "@angular/forms";
import { NgFor, NgIf } from "@angular/common";

@Component({
  selector: "app-qbo-accounts-modal",
  templateUrl: "./qbo-accounts-modal.component.html",
  styleUrls: ["./qbo-accounts-modal.component.scss"],
  imports: [NgFor, NgIf, FormsModule, TypeaheadModule],
})
export class QboAccountsModalComponent implements OnInit, OnDestroy {
  companyAccounts = [];
  account: any = {};
  selectedAccount: any = {};

  constructor(
    private qbServices: QuickbooksIntegrationService,
    public bsModalRef: BsModalRef,
  ) {}

  ngOnInit() {
    this.qbServices
      .getAccountsByCompanyId(this.account.workspace_id)
      .subscribe((res: any) => {
        this.account.accounts = res;
      });

    this.qbServices
      .getCompanyAccounts(this.account.workspace_id)
      .then((res) => {
        this.companyAccounts = res;
      });
  }

  ngOnDestroy(): void {
    this.selectedAccount = {};
  }

  addAccountToCompany(workspaceId) {
    console.log(workspaceId, this.selectedAccount);
    this.qbServices
      .addAccountToCompany(workspaceId, {
        accountId: this.selectedAccount.id,
        accountName: this.selectedAccount.name,
        accountPath: this.selectedAccount.path,
      })
      .then((res) => {
        this.companyAccounts.push(res);
        this.selectedAccount = {};
        this.account.account_name = "";
        this.account.account_path = "";
      });
  }

  selectAccount(event: TypeaheadMatch) {
    this.selectedAccount = event.item;
  }

  deleteCompanyAccountLink(linkUuid) {
    this.qbServices.deleteCompanyAccountLink(linkUuid).then((res) => {
      this.companyAccounts = this.companyAccounts.filter(
        (link) => link.uuid !== linkUuid,
      );
    });
  }
}
